import { reactive, ref, Ref, watch } from "vue";
import { useRafFn } from "@vueuse/core";
import { Media } from "vue-audio-visual";
import { drawAVMedia } from "vue-audio-visual";
import { setAnalyserAVMedia } from "vue-audio-visual";
export function useAVMedia<T extends object>(
  canvas: Ref<HTMLCanvasElement | null>,
  props: T
) {
  const p = reactive({
    ...{
      media: null,
      type: null,
      canvWidth: null,
      canvHeight: null,
      frequLnum: null,
      frequDirection: null,
      lineColor: null
    },
    ...props
  });
  let analyser: AnalyserNode;

  const ctx = ref<any | null>();

  const { pause, resume } = useRafFn(
    () => {
      if (!analyser) {
        return;
      }
      drawAVMedia(analyser, ctx, new Media(p as any));
    },
    { immediate: false }
  );

  watch(
    () => [canvas.value, p.canvWidth, p.canvHeight],
    ([v1, v2, v3]) => {
      if (!v1) {
        ctx.value = null;
        return;
      }

      ctx.value = v1.getContext("2d");
      if (v2) {
        v1.width = +v2;
      }
      if (v3) {
        v1.height = +v3;
      }
    }
  );

  watch(
    () => p.media,
    stream => {
      if (stream) {
        analyser = setAnalyserAVMedia(
          (stream as unknown) as MediaStream,
          new Media(p as any)
        );
        resume();
      } else {
        pause();
      }
    },
    { immediate: true }
  );

  return p;
}
